import * as React from 'react';
import { Modal, Form, Input, Button } from 'antd';
import AceEditor from 'react-ace';
import 'brace/mode/mysql';
import 'brace/theme/xcode';
import { ScriptRevision } from '../../types';
import { ScriptManagementStore } from '../../stores';
import { Utils } from '../../../common/services/Utils';

type Props = {
    revision: ScriptRevision | null;
    onClose: () => void;
    onRestore: (revision: ScriptRevision) => void;
    store: ScriptManagementStore;
};

const RevisionViewModal: React.FC<Props> = ({ store, revision, onClose, onRestore }) => {
    if (!revision) {
        return null;
    }

    const handleRestore = () => {
        onRestore(revision);
    };

    return (
        <Modal
            title={`Revision - ${Utils.formatDateStringShort(revision.createDate)}`}
            visible={store.isRevisionModalVisible}
            onCancel={onClose}
            width={800}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Close
                </Button>,
                <Button key="restore" type="primary" onClick={handleRestore} loading={store.isRestoring}>
                    Restore
                </Button>
            ]}
        >
            <Form layout="vertical" className="script-revision-view">
                <Form.Item label="Name">
                    <Input value={revision.name} disabled />
                </Form.Item>

                <Form.Item label="Description">
                    <Input.TextArea value={revision.description || 'N/A'} disabled rows={1} />
                </Form.Item>

                <Form.Item label="Created By">
                    <Input value={store.getUserNameById(revision.createdBy)} disabled />
                </Form.Item>

                <Form.Item label="Created Date">
                    <Input value={Utils.formatDateStringShort(revision.createDate)} disabled />
                </Form.Item>

                <Form.Item label="SQL Body">
                    <AceEditor
                        mode="mysql"
                        theme="xcode"
                        name="sql-revision-body-viewer"
                        value={revision.body}
                        readOnly
                        width="100%"
                        height="300px"
                        editorProps={{ $blockScrolling: true }}
                        setOptions={{
                            showLineNumbers: true,
                            tabSize: 2,
                            readOnly: true
                        }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default RevisionViewModal;
